var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { breakpoint, Modal } from '@bfa/common-ui';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useBusinessConfiguration from '../../../../../hooks/useBusinessConfiguration';
import { ONBOARDING_SECTION_EVENTS as EVENTS } from '../../../../../utils/analytics/events';
import { setShowOnboardingTourCookie, setShowOnboardingTourNewbiesCookie, } from '../../../../../utils/cookies';
import Content from './Content';
var setCookiesToFalse = function () {
    setShowOnboardingTourCookie(false);
    setShowOnboardingTourNewbiesCookie(false);
};
var OnboardingModal = styled(Modal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  div[role='dialog'] > div {\n    border-radius: 1rem;\n    max-width: 90rem;\n    padding: 1.5rem;\n    max-height: 100vh;\n    @media (min-width: ", ") {\n      max-height: 90vh;\n    }\n  }\n"], ["\n  div[role='dialog'] > div {\n    border-radius: 1rem;\n    max-width: 90rem;\n    padding: 1.5rem;\n    max-height: 100vh;\n    @media (min-width: ", ") {\n      max-height: 90vh;\n    }\n  }\n"])), breakpoint('sm'));
var OnboardingTour = function (_a) {
    var content = _a.content, isOpen = _a.isOpen;
    var trackEvent = useBusinessConfiguration().trackEvent;
    var _b = __read(useState(0), 2), step = _b[0], setStep = _b[1];
    var _c = __read(useState(isOpen || false), 2), open = _c[0], setOpen = _c[1];
    var steps = __spreadArray(__spreadArray([
        {
            mobileImage: content.introductionMobileImage,
            desktopImage: content.introductionDesktopImage,
            title: content.introductionTitle,
            description: content.introductionDescription,
            edgeButtonText: content.introductionButtonText,
            edgeLinkText: content.introductionLinkText,
        }
    ], __read(content.steps), false), [
        {
            mobileImage: content.conclusionMobileImage,
            desktopImage: content.conclusionDesktopImage,
            title: content.conclusionTitle,
            description: content.conclusionDescription,
            edgeButtonText: content.conclusionButtonText,
        },
    ], false);
    var onEdgeButtonClick = function () {
        var nextStep = step + 1;
        if (nextStep <= steps.length - 1) {
            setStep(nextStep);
            if (nextStep <= 1) {
                trackEvent(EVENTS.CLICK_ON_TAKE_TOUR);
            }
        }
        else {
            trackEvent(EVENTS.CLICK_ON_END_TOUR);
            setOpen(false);
            setCookiesToFalse();
        }
    };
    var onEdgeLinkClick = function () {
        setOpen(false);
        setCookiesToFalse();
        trackEvent(EVENTS.CLICK_ON_SKIP_TOUR);
    };
    useEffect(function () {
        setOpen(!!isOpen);
    }, [isOpen]);
    return (React.createElement(OnboardingModal, { isOpen: open },
        React.createElement(Content, { numberSteps: steps.length, currentStep: step, mobile: steps[step].mobileImage, desktop: steps[step].desktopImage, title: steps[step].title, description: steps[step].description, edgeButtonText: steps[step].edgeButtonText, edgeLinkText: steps[step].edgeLinkText, onEdgeButtonClick: onEdgeButtonClick, nextButtonText: content.nextButtonText, onEdgeLinkClick: onEdgeLinkClick })));
};
export default OnboardingTour;
var templateObject_1;
